var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Heading, Box, LinkBox, LinkOverlay, Text } from '@chakra-ui/react';
import './News.css';
var ArticleLink = function (props) {
    var date = new Date(props.time);
    var options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    return (_jsxs(LinkBox, __assign({ as: "article", maxW: "sm", p: "5", borderWidth: "1px", rounded: "md", className: "link-box" }, { children: [_jsx(Box, __assign({ as: "time", dateTime: date.getUTCDate.toString() }, { children: date.toLocaleDateString('en-us', options) })), _jsx(Heading, __assign({ size: "md", my: "3", className: "heading", noOfLines: 1 }, { children: _jsx(LinkOverlay, __assign({ href: props.url, target: "_blank" }, { children: props.heading })) })), _jsx(Text, __assign({ className: "desc", textOverflow: 'ellipsis', noOfLines: 4 }, { children: props.description }))] })));
};
export default ArticleLink;
